import { UploadFileStatus } from 'antd/es/upload/interface';
import classNames from 'classnames';
import React from 'react';

import { DropZonePreviewIcon } from '../../DropZonePreviewIcon';
import styles from './styles.module.scss';

interface Props {
  progress?: number;
  title?: string;
  uploadState?: UploadFileStatus | 'converting' | null;
}

export const DropZonePreviewCompact = ({ progress, title, uploadState }: Props) => (
  <div className={classNames(styles.preview)}>
    <DropZonePreviewIcon
      progress={progress}
      uploadState={uploadState}
      iconClassName={styles.icon}
    />
    <div className={styles.title}>{title}</div>
  </div>
);
